/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const fr_about_me_description_1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Je suis un ingénieur logiciel et entrepreneur passionné par la conception de produits numériques performants et évolutifs. Etant spécialisé dans les architectures modernes (TypeScript, Deno, SvelteKit, microservices), je conçois des plateformes robustes orientées sécurité, performance et expérience utilisateur.`)
};

const en_about_me_description_1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I'm a passionate software engineer and entrepreneur focused on designing high-performance, scalable digital products. Being specialized in modern architectures (TypeScript, Deno, SvelteKit, microservices), I build robust platforms oriented towards security, performance, and user experience.`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const about_me_description_1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.about_me_description_1(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("about_me_description_1", locale)
	if (locale === "fr") return fr_about_me_description_1(inputs)
	return en_about_me_description_1(inputs)
};